import React from 'react';
import compose from 'recompose/compose';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import PropTypes from 'prop-types';
import Dialog, {
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import { withStyles } from 'material-ui/styles';
import { MAILCHIMP_ACTION_URL } from '../../../constants/config';
import SubscribeForm from './SubscribeForm';

const styles = () => ({
  p: {
    marginBottom: '1em',
  }
});

const DialogMessage = ({classes}) => (
  <div>
    <DialogContentText className={classes.p}>
      Thanks for registering to use ITEQ Stackup Pro
      <span role="img" aria-label="Smile">😀</span>
    </DialogContentText>
    <DialogContentText className={classes.p}>
      We will be making the Beta version of our 3D stackup tool
      available to a select group of early users, and we appreciate
      your feedback on usability, function and features of the tool. 
    </DialogContentText>
    <DialogContentText className={classes.p}>
      In return for your support, we&apos;ll be giving away prizes periodically
      to users that offer helpful feedback. We will be communicating
      the official launch date to you via email, thanks again for signing up!
    </DialogContentText>
  </div>
);

class SignupDialog extends React.Component {
  // state = {
  //   name: '',
  //   email: '',
  // }
  
  // handleChnage = key => event => {
  //   this.setState({
  //     [key]: event.target.value,
  //   });
  // }

  // onSubmit() {
  //   const { onClose } = this.props;
  //   onClose(this.state);
  // }

  // onCancel() {
  //   const { onClose } = this.props;
  //   onClose();
  // }

  constructor() {
    super();
    this.renderSubscribeForm = this.renderSubscribeForm.bind(this);
  }
  
  renderSubscribeForm({ subscribe, status, message }) {
    const { onClose, classes } = this.props;
    return (
      <SubscribeForm
        status={status}
        message={message}
        onValidated={formData => subscribe(formData)}
        onClose={onClose}
        text={<DialogMessage classes={classes} />}
      />
    );
  }


  render() {
    const { fullScreen, open, onClose } = this.props;

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={onClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            Sign up!
          </DialogTitle>
          <DialogContent>
            <MailchimpSubscribe
              url={MAILCHIMP_ACTION_URL}
              render={this.renderSubscribeForm}
            />
          </DialogContent>
          {/* <DialogActions>
            <Button onClick={onCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={onSubmit} color="primary" autoFocus>
              Sign up! 
            </Button>
          </DialogActions> */}
        </Dialog>
      </div>
    );
  }
}

SignupDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
  withMobileDialog(),
  withStyles(styles)
)(SignupDialog);


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/SignupDialog.jsx